<!--工单类型管理界面-->
<template>
  <div class="myorderTypeContainer">
    <div class="con">

      <div class="search-input-btn">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small">
              <span>紧急程度：</span>
              <el-select v-model="form.priority" clearable placeholder="请选择">
                <el-option v-for="item in priorityList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" size="mini" plain @click="search" class="search-btn">查询</el-button>
          </div>
        </el-scrollbar>
      </div>
      <div class="orderTypeList" :style="{'height':heights+'px'}">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-is">
            <div class="list-item" v-for="(item,index) in filterDataList" :key="index">
              <div class="item-top">
                <span>{{item.name}}</span>
              </div>
              <div class="item-con">
                <p>创建时间：2021-01-04</p>
                <p>创建人：{{index+1}}</p>
                <p>紧急程度：
                  <span class="myemergent mutongyong" v-if="item.priority =='Emergent'">紧急</span>
                  <span class="myhigh mutongyong" v-if="item.priority =='High'">高</span>
                  <span class="mystandard mutongyong" v-if="item.priority =='Standard'">标准</span>
                  <span class="mylow mutongyong" v-if="item.priority =='Low'">低</span>
                  <span v-if="item.priority =='--'">--</span>
                </p>
              </div>
              <div class="item-btn">
                <div @click="editOrderType(item)" class="btns" style="margin-right:24px">
                  <span>编辑</span>
                  <elIconBtn btnType='edit'></elIconBtn>
                </div>
                <div @click="deleteOrderType(item)" class="btns">
                  <span>删除</span>
                  <elIconBtn btnType='del'></elIconBtn>
                </div>
              </div>
            </div>
            <div class="list-item-add" @click="addOrderType">
              <div class="heng"></div>
              <div class="shu"></div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <UpdateOrderTypeDialog ref='updateOrderType'></UpdateOrderTypeDialog>
    </div>
  </div>
</template>

<script>
  import elIconBtn from '@/components/module/iconBtns.vue'
  import UpdateOrderTypeDialog from './UpdateOrderTypeDialog.vue'
  export default {
    components: {
      UpdateOrderTypeDialog,
      elIconBtn
    },
    props: {},
    data () {
      return {
        heights: Math.round((document.getElementById('app').clientHeight)*0.75),//屏幕高度 - 导航栏高度
        form: {
          priority: ''
        },
      }
    },
    created () {},
    mounted () {
    },
    destroyed () {},
    computed: {
      priorityList () {
        return this.$store.orderGroupStore.state.priorityList
      },
      dataList () {
        return this.$store.orderGroupStore.getters.getOrderGroupTree
      },
      priorityMatch () {
        return this.$store.orderGroupStore.state.priorityMatch
      },
      filterDataList () {
        return isempty(this.dataList)? []:this.dataList.filter(item => {
          return this.form.priority==''||this.form.priority==item.priority
        })
      },
    },
    watch: {
      filterDataList (val) {}
    },
    //过滤器
    filters: {

      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
    methods: {
      search () {
        this.$store.orderGroupStore.commit('getOrderGroupTree')
      },
      addOrderType () {
        this.$refs.updateOrderType.open('新建工单类型',{},result => {
          var sort=0
          this.dataList.forEach(item => {
            sort=sort<item.sort? item.sort:sort
          })
          sort+=1
          this.save(result.name,result.priority,undefined,sort)
        })
      },
      save (name,priority,parentId,sort) {
        this.$api.orderGroupApi.addOrderGroup(name,priority,parentId,sort,res => {
          this.$message({
            message: '保存成功!',
            type: 'success'
          })
          this.search()
        },err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      },
      deleteOrderType (item) {
        if([1,2,3].includes(item.groupId)) {
          this.$message({
            message: '默认分组不允许删除!',
            type: 'warning'
          })
          return
        }
        this.$dialogMethod.openAgreeDialog('删除工单组','删除后所有此分组下工单将归入未分组工单，是否继续?',respon => {
          this.$api.orderGroupApi.deleteOrderGroup(item.groupId,respon => {
            this.search()
          })
        })
      },
      editOrderType (item) {
        if([1,2,3].includes(item.groupId)) {
          this.$message({
            message: '默认分组不允许编辑!',
            type: 'warning'
          })
          return
        }
        this.$refs.updateOrderType.open('编辑工单类型',{name: item.name,priority: item.priority},result => {
          this.$api.orderGroupApi.updateOrderGroup(item.groupId,result.name,result.priority,respon => {
            this.$message({
              message: '编辑工单类型成功!',
              type: 'success'
            })
            this.search()
          },err => {
            this.$message({
              message: err,
              type: 'error'
            })
          })
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .myorderTypeContainer {
    .con {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 2px 20px 12px 20px;
      box-sizing: border-box;

      .orderTypeList {
        width: 100%;
        height: 700px;

        .my-search-is {
          display: flex;
          flex-wrap: wrap;
        }
      }

      .list-item {
        width: 266px;
        height: 200px;
        border: 1px solid #e6e6e6;
        border-radius: 2px;
        margin-right: 12px;
        margin-bottom: 12px;

        .item-top {
          width: 100%;
          height: 44px;
          background-color: #368ed9;
          line-height: 44px;

          span {
            font-size: 16px;
            color: #fff;
            margin-left: 20px;
          }
        }

        .item-con {
          color: #1a1a1a;
          font-size: 14px;
          margin: 20px 10px 33px 20px;

          p {
            margin-bottom: 5px;
          }

          .mutongyong {
            display: inline-block;
            width: 36px;
            height: 22px;
            text-align: center;
            line-height: 22px;
          }

          //紧急
          .myemergent {
            color: #FF1D1D;
            background-color: #FFE7E7;
          }

          //高
          .myhigh {
            color: #BF458E;
            background-color: #FFE9F6;
          }

          //标准
          .mystandard {
            color: #5452C9;
            background-color: #E5E8FF;
          }

          //低
          .mylow {
            color: #2981D2;
            background-color: #DEF3FF;
          }

        }

        .item-btn {
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;

          .btns {
            display: flex;
            margin-right: 12px;

            span {
              margin-right: 4px;
              color: #999;
            }
          }
        }
      }

      .list-item-add {
        width: 266px;
        height: 200px;
        border: 1px dashed #e6e6e6;
        border-radius: 2px;
        position: relative;

        &:hover {
          border-color: #368ed9;

          .heng {
            background-color: #368ed9;
          }

          .shu {
            background-color: #368ed9;
          }
        }

        .heng {
          width: 90px;
          height: 1px;
          background-color: #cccccc;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .shu {
          width: 1px;
          height: 90px;
          background-color: #cccccc;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }



    }
  }
</style>